// dont use export * syntax suger as its looking liek it wont be supported in ES-Next.
// eslint-disable-next-line import/no-named-as-default
export { default } from './components/ApplicationContainer';
export { default as ComponentHost } from './components/ComponentHost';
export { default as host } from './lib/host';
